import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {} from "../../../../Redux/Actions/actions";
import nodata from "../../../../Assets/images/svg/Data-unavailable.svg";
import {
  DownloadSimple,
  Export,
  File,
  Image,
  VideoCamera,
  Waveform,
} from "@phosphor-icons/react";
import { IconButton, Stack, Typography } from "@mui/material";
import { fileservice } from "../../../../Container/BaseUrl/BaseUrl";
const mapStateToProps = (state) => {
  return {
    externalChatData: state.contactListData.externalChatData,
  };
};

const FilesTab = (props) => {
  const [filename, setFilename] = useState([]);

  const allfile = async () => {
    await axios
      .post(
        fileservice + "/fileServer/getMediaUserId",
        {
          userId: props.externalChatData.phonenumber,
          offset: 0,
          limit: 5,
        },
        {
          headers: {
            TenantId: "123456",
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setFilename(res.data.data);
        } else {
          setFilename([]);
        }
      })
      .catch((err) => {
        setFilename([]);
      });
  };
  useEffect(() => {
    allfile();
  }, [props.externalChatData]);

  const handleDownload = (url) => {
    const popupWidth = 700;
    const popupHeight = 500;
    const left = (screen.width - popupWidth) / 2;
    const top = (screen.height - popupHeight) / 2;
    const popupWindow = window.open(
      url,
      "_blank",
      `width=${popupWidth},height=${popupHeight},top=${top},left=${left}`
    );
    if (
      !popupWindow ||
      popupWindow.closed ||
      typeof popupWindow.closed === "undefined"
    ) {
      alert("Popup blocker is enabled. Please allow popups for this site.");
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-end"
        style={{ height: "5px" }}
      ></div>
      <div
        className="historynew CONTACT-LIST-AREA"
        style={{
          height: "calc(100% - 5px)",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        {filename.length ? (
          filename.map((item) => {
            return (
              <div
                className="row m-2 border p-2 justify-content-center align-items-center bg-white"
                style={{ borderRadius: "7px" }}
              >
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  sx={{ color: "#1473e6" }}
                >
                  <Stack direction={"row"} alignItems={"center"} spacing={1}>
                    {item.extension == "png" ? (
                      <Image
                        size={40}
                        cursor={"pointer"}
                        color={item.sentBy == "Agent" ? "#1473e6" : "#DB3240"}
                      />
                    ) : item.extension == "wav" ? (
                      <Waveform
                        size={40}
                        cursor={"pointer"}
                        color={item.sentBy == "Agent" ? "#1473e6" : "#DB3240"}
                      />
                    ) : item.extension == "mp4" ? (
                      <VideoCamera
                        size={40}
                        cursor={"pointer"}
                        color={item.sentBy == "Agent" ? "#1473e6" : "#DB3240"}
                      />
                    ) : (
                      <File
                        size={40}
                        cursor={"pointer"}
                        color={item.sentBy == "Agent" ? "#1473e6" : "#DB3240"}
                      />
                    )}
                    <Stack>
                      <Typography
                        variant="subtitle2"
                        noWrap
                        sx={{
                          fontWeight: 600,
                          color: "#0B3363",
                          fontSize: "13px",
                        }}
                      >
                        {item.path.split("/")[1]}
                      </Typography>

                      <Typography
                        variant="caption"
                        sx={{ fontSize: "12px", color: "#c0c0c0" }}
                      >
                        {moment(item.createdDate).format("l   hh:mm:s A")}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack direction={"row"} spacing={0.5}>
                    <IconButton
                      onClick={() => {
                        handleDownload(item.signedUrl);
                      }}
                    >
                      <DownloadSimple
                        size={20}
                        cursor={"pointer"}
                        weight="bold"
                      />
                    </IconButton>

                    {/* <IconButton
                      disabled
                      onClick={() => {
                        props.handleSendMsg(
                          item.signedUrl,
                          item.extension == "png"
                            ? "png"
                            : item.extension == "wav"
                              ? "AUDIO"
                              : item.extension == "pdf"
                                ? "pdf"
                                : item.extension == "mp4"
                                  ? "mp4"
                                  : item.extension == "jpeg"
                                    ? "jpeg"
                                    : "",
                          item.originalName
                        );
                      }}
                    >
                      <Export size={20} weight="bold" />
                    </IconButton> */}
                  </Stack>
                </Stack>
              </div>
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <span className="mx-auto">
              <img
                src={nodata}
                alt="nodata"
                style={{ width: "13rem", userSelect: "none" }}
              />
            </span>
            <span className="mx-auto">
              <h6 className="text-muted mt-2 fs-13">No data found</h6>
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default connect(mapStateToProps, {})(FilesTab);
